<template>
  <svg
    width="26"
    height="36"
    viewBox="0 0 26 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.1 10.5V10.4H3C2.36348 10.4 1.75303 10.1471 1.30294 9.69706C0.852856 9.24697 0.6 8.63652 0.6 8V3C0.6 2.36348 0.852856 1.75303 1.30294 1.30294C1.75303 0.852856 2.36348 0.6 3 0.6H23C23.6365 0.6 24.247 0.852856 24.6971 1.30294C25.1471 1.75303 25.4 2.36348 25.4 3V8C25.4 8.63652 25.1471 9.24697 24.6971 9.69706C24.247 10.1471 23.6365 10.4 23 10.4H22.9V10.5V33C22.9 33.6365 22.6471 34.247 22.1971 34.6971C21.747 35.1471 21.1365 35.4 20.5 35.4H5.5C4.86348 35.4 4.25303 35.1471 3.80294 34.6971C3.35286 34.247 3.1 33.6365 3.1 33V10.5ZM5.5 15.4H5.4V15.5V28V28.1H5.5H9.25H9.35V28V15.5V15.4H9.25H5.5ZM20.5 33.1H20.6V33V10.5V10.4H20.5H5.5H5.4V10.5V13V13.1H5.5H11.65V30.4H5.5H5.4V30.5V33V33.1H5.5H20.5ZM2.9 8V8.1H3H23H23.1V8V3V2.9H23H3H2.9V3V8Z"
      fill="var(--livi-primary)"
      stroke="white"
      stroke-width="0.2"
    />
  </svg>
</template>
